export default __webpack_public_path__ + "static/media/linkedin-icon.096672a1.png";